import {useFormik} from 'formik'
import {ModeleDemandeDemontage} from '../../../../components/Models'
import React, {useState} from 'react'
import {TextInput} from '../../../../components/inputs/TextInput'
import {Button} from 'react-bootstrap'
import {useAuth} from '../../../modules/auth'
import * as Yup from 'yup'
import {refuserDemandeDemontage} from '../../../../components/requests'
import {toast} from 'react-toastify'

const RefusDemontageRealisationForm = (props) => {
  const {
    showModalProp,
    demandeDemontageId,
    checkedPieces,
    setCheckedPieces,
    data,
    setData,
    vehiculeId,
  } = props
  const {currentUser} = useAuth()

  const initialValues: ModeleDemandeDemontage = {
    commentaire: '',
  }

  const [loading, setLoading] = useState(false)

  const onSubmitHandler = (values) => {
    setLoading(true)

    // Récupère les pièces non encore réalisées
    const nonRealisedIds = data[0]?.demandeTypePiece
      ?.filter((item) => !item.realise && item.refus === null)
      ?.map((item) => item.id)

    const toSubmitIds = checkedPieces.filter((id) => nonRealisedIds.includes(id))
    refuserDemandeDemontage(demandeDemontageId, toSubmitIds.join(','), values.commentaire).then(
      (res) => {
        if (res?.status === 200 && res.data) {
          setLoading(false)
          showModalProp(false)
          const dataTab = [res.data]
          const updatedData = data.map((item, index) => ({
            ...item,
            statut: { ...dataTab[0].statut },
            demandeTypePiece: [...dataTab[0].demandeTypePiece],
          }))

          const pieces = dataTab[0]?.demandeTypePiece || []
          const stillNotRealised =
            pieces
              ?.filter((item) => !item.realise && item.refus === null)
              ?.map((item) => item.id) || []
          setCheckedPieces(stillNotRealised.filter((id) => checkedPieces.includes(id)))
          setData(updatedData)

          toast.success('Démontage de pièce réfusé')
        } else {
          setLoading(false)
        }
      }
    )
  }

  const validationSchema = Yup.object().shape({
    commentaire: Yup.string().trim().required('Le champ motif est requis.'),
  })

  const formik = useFormik<ModeleDemandeDemontage>({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: onSubmitHandler,
    validateOnBlur: true,
    validateOnChange: true,
  })

  return (
    <div>
      <form action='#' onSubmit={formik.handleSubmit}>
        <div className='App'>
          <div className='modal-body pt-3'>
            <div className='row'>
              <div className='col-sm-12'>
                <label className='col-lg-4 col-form-label required fw-bold fs-6'>Motif</label>
                <TextInput
                  fieldName={'commentaire'}
                  inputType={'text'}
                  inputClassName={'form-control form-control-lg mb-3 mb-lg-0'}
                  formik={formik}
                />
              </div>
            </div>
          </div>
          <div className='modal-footer'>
            <div className='row'>
              <div className='col-sm-12' style={{textAlign: 'right'}}>
                <Button variant='secondary me-5' onClick={() => showModalProp(false)}>
                  Annuler
                </Button>
                <Button
                  variant='info'
                  type='submit'
                  disabled={!formik.isValid || !formik.dirty || loading}
                >
                  {!loading && 'Valider'}
                  {loading && (
                    <span className='indicator-progress' style={{display: 'block'}}>
                      Validation...{' '}
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  )
}

export {RefusDemontageRealisationForm}
